import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-tertiary)";

function IconScreenVariant({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M7.784 10.898a.994.994 0 0 0 .712-.109l4.985-2.87a.999.999 0 0 0 .34-.321c.198.303.216.696.054 1.016a.994.994 0 0 1-.394.413l-4.985 2.87a.993.993 0 0 1-.992 0l-4.985-2.87a.994.994 0 0 1-.394-.413 1.026 1.026 0 0 1 .054-1.016.998.998 0 0 0 .34.32l4.985 2.871a.994.994 0 0 0 .28.11z"/>
            <path fill={fill} d="M7.784 13.367a.994.994 0 0 0 .712-.109l4.985-2.87a.999.999 0 0 0 .34-.321c.198.303.216.697.054 1.016a.993.993 0 0 1-.394.413l-4.985 2.871a.993.993 0 0 1-.992 0l-4.985-2.87a.993.993 0 0 1-.394-.414 1.026 1.026 0 0 1 .054-1.016.998.998 0 0 0 .34.32l4.985 2.871a.994.994 0 0 0 .28.11z"/>
            <path fill={fill} fill-opacity="0.4" stroke={fill} d="M2.754 5.098 7.75 2.221a.5.5 0 0 1 .5 0l4.996 2.877a.5.5 0 0 1 0 .867L8.25 8.842a.5.5 0 0 1-.5 0L2.754 5.965a.5.5 0 0 1 0-.867z"/>
        </svg>
    );
}

export default IconScreenVariant;
